import { api } from './client'

export interface MailInbox {
  id: number
  address: string
  label: string | null
  is_random: boolean
  last_email_at: string | null
  created_at: string
  unread_count?: number
}

export interface MailListItem {
  id: number
  from_address: string
  from_name: string | null
  subject: string | null
  auth_code: string | null
  read_at: string | null
  received_at: string
  has_attachments: boolean
}

export interface MailMessage extends MailListItem {
  text_body: string | null
  html_body: string | null
  attachment_names: string[] | null
}

export const mailApi = {
  listInboxes: () => api.get<{ inboxes: MailInbox[] }>('/mail/inboxes'),
  createInbox: (body: { address?: string; label?: string }) =>
    api.post<{ inbox: MailInbox }>('/mail/inboxes', body),
  deleteInbox: (id: number) => api.delete<{ ok: boolean }>(`/mail/inboxes/${id}`),
  // messages() do Laravel devolve o paginator completo (data, current_page, next_page_url, ...); a página lê só .data
  listMessages: (id: number) =>
    api.get<{ data: MailListItem[]; current_page: number; next_page_url: string | null }>(
      `/mail/inboxes/${id}/messages`,
    ),
  getMessage: (id: number) => api.get<{ message: MailMessage }>(`/mail/messages/${id}`),
}
